import * as yup from "yup";
import { PreferredTimeSlot } from "features/Resources/Meeting/models";
import { OffsetUnit } from "features/Resources/MeetingTemplate/models";
import { MeetingReferenceEvent } from "../models";

export const meetingTemplateTimingSchema = yup.object({
  durationMinutes: yup.number().required().label("Duration (minutes)"),
  referenceEvent: yup.mixed<MeetingReferenceEvent>().required().label("Event"),
  offset: yup.number().required().integer().label("Offset"),
  offsetUnit: yup
    .mixed<OffsetUnit>()
    .label("Day/Week/Month")
    .when("offset", {
      is: (value: number) => value !== 0,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired(),
    }),
  allowWeekends: yup.boolean().default(false),
  useSpecificTime: yup.boolean().default(false),
  specificTimeOfDay: yup
    .string()
    .nullable()
    .when("useSpecificTime", {
      is: true,
      then: (schema) =>
        schema.required("Please select a specific time").matches(/^\d{2}:\d{2}$/, "Time must be in HH:MM format"),
      otherwise: (schema) => schema.notRequired(),
    }),
  preferredTimeSlot: yup
    .mixed<PreferredTimeSlot>()
    .nullable()
    .when("useSpecificTime", {
      is: false,
      then: (schema) => schema.required().label("Time of Day"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export type MeetingTemplateTimingSchema = yup.InferType<typeof meetingTemplateTimingSchema>;
